import script from "./SplashScreenComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SplashScreenComponent.vue?vue&type=script&setup=true&lang=ts"

import "./SplashScreenComponent.vue?vue&type=style&index=0&id=3669ddf2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3669ddf2"]])

export default __exports__